/*
 * File: d:\projects\AutoFiFront\src\Theme\Component\SocialMedia.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday March 28th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday March 28th 2023 4:10:24 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import styled from "styled-components";

const SocialMedia = styled.a.attrs((props: any) => ({
    bgColor: props.bgColor,
}))`
display: flex;
justify-content: center;
align-items: center;
width: 3rem;
height: 3rem;
font-size: 2rem;
color: var(--text-color-first);
&:hover{
    border-radius: 99px;
    color: ${(props: any) => props.bgColor};
    box-shadow: 0 0 5px 7px ${props => props.bgColor};
    background-color: white;
    transition: 0.2s ease-in-out;
}
`;

export default SocialMedia;
